<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.75717 5.929C6.92917 4.757 8.46417 4.172 10.0002 4.172C11.5362 4.172 13.0712 4.758 14.2432 5.929L17.8992 9.586V6H19.8992V13H12.8992V11H16.4852L12.8282 7.343C12.4576 6.97042 12.0169 6.67501 11.5315 6.47384C11.0461 6.27267 10.5256 6.16974 10.0002 6.171C8.93217 6.171 7.92717 6.587 7.17217 7.343C6.42296 8.09367 6.00218 9.11092 6.00218 10.1715C6.00218 11.2321 6.42296 12.2493 7.17217 13L12.5362 18.364L11.1222 19.778L5.75817 14.414C5.20088 13.857 4.75877 13.1956 4.45711 12.4677C4.15544 11.7398 4.00013 10.9596 4.00004 10.1717C3.99994 9.38377 4.15507 8.60353 4.45657 7.87556C4.75806 7.14759 5.20001 6.48614 5.75717 5.929Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGRedo',
};
</script>

<style scoped>

</style>
